
import React from "react";
import { InvoiceStatus } from "@/types/payments";
import { useTranslations } from "use-intl";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface StatusFilterProps {
  status: InvoiceStatus | 'all';
  onStatusChange: (status: InvoiceStatus | 'all') => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({ status, onStatusChange }) => {
  const t = useTranslations("consultantPayables");
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">{t("filters.status")}</label>
      <Select 
        value={status} 
        onValueChange={(value) => onStatusChange(value as InvoiceStatus | 'all')}
      >
        <SelectTrigger>
          <SelectValue placeholder={t("filters.filterByStatus")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t("filters.allStatuses")}</SelectItem>
          <SelectItem value="unpaid">{t("status.unpaid")}</SelectItem>
          <SelectItem value="pending">{t("status.pending")}</SelectItem>
          <SelectItem value="paid">{t("status.paid")}</SelectItem>
          <SelectItem value="manually_handled">{t("status.manually_handled")}</SelectItem>
          <SelectItem value="overdue">{t("status.overdue")}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default StatusFilter;
